import React, { useEffect, useContext, ReactElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectCreditApplication } from 'state/creditApplication';
import { resetApplication } from 'state/resetApplication';
import useQueryParameters from 'hooks/useQueryParameters';
import {
  CachedAttributes,
  mergeCachedAttributes,
  selectCachedAttributes,
} from 'state/cachedAttributes';

export const CachedAttributesContext = React.createContext<CachedAttributes>({
  applicantEmail: null,
  storeNumber: null,
  cardChoice: null,
  selectedCardKey: null,
});

export const useCachedAttribute: () => CachedAttributes = () => {
  return useContext(CachedAttributesContext);
};

const ResetApplicationRoute: React.FC = ({ children }) => {
  const {
    emailAddress,
    storeNumber: appStoreNumber,
    cardChoice,
    selectedCardKey,
  } = useSelector(selectCreditApplication);

  const { storeNumber: queryStoreNumber } = useQueryParameters();

  const dispatch = useDispatch();

  const attributes = {
    applicantEmail: emailAddress,
    storeNumber: queryStoreNumber || appStoreNumber,
    cardChoice: cardChoice,
    selectedCardKey: selectedCardKey,
  };

  useEffect(() => {
    dispatch(resetApplication());
    dispatch(mergeCachedAttributes(attributes));
    // Ensure we only sent this once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cachedAttributes = useSelector(selectCachedAttributes);

  return (
    <>
      <CachedAttributesContext.Provider value={cachedAttributes}>
        {React.Children.map(children, child =>
          React.cloneElement(child as ReactElement),
        )}
      </CachedAttributesContext.Provider>
    </>
  );
};

export default ResetApplicationRoute;
